<template>
  <v-container fill-height fluid grid-list-xl>
    <material-tabs :tabs="tabs">
      <v-flex slot="body" xs12>
        <router-view />
      </v-flex>
    </material-tabs>
  </v-container>
</template>

<script>
import MaterialTabs from '@/components/material/Tabs';
import { config } from '@/utils/config';

// @vuese
// Wyświetlanie profilu klienta
// @group Client
export default {
  components: {
    MaterialTabs
  },
  data() {
    const tabs = [
      {
        name: 'Profil',
        route: `/clients/${this.$route.params.id}`,
        icon: 'mdi-folder-account',
        permission: ['PROFILE.GET', 'USER.GET']
      },
      {
        name: 'Historia',
        route: `/clients/${this.$route.params.id}/history`,
        icon: 'mdi-history',
        permission: ['HISTORY.LIST']
      },
      {
        name: 'Użycie',
        route: `/clients/${this.$route.params.id}/usage`,
        icon: 'mdi-chart-timeline',
        permission: ['BENEFIT_USE.LIST']
      },
      {
        name: 'Karty',
        route: `/clients/${this.$route.params.id}/cards`,
        icon: 'mdi-account-card-details-outline',
        permission: ['CARD.LIST']
      },
      {
        name: 'Grupy',
        route: `/clients/${this.$route.params.id}/groups`,
        icon: 'mdi-account-group',
        permission: ['GROUP.LIST']
      },
      {
        name: 'Wnioski',
        route: `/clients/${this.$route.params.id}/applications`,
        icon: 'mdi-file',
        permission: ['APPLICATION.LIST']
      }
    ];

    if (config.modules.points) {
      tabs.push({
        name: 'Punkty',
        route: `/clients/${this.$route.params.id}/points`,
        icon: 'mdi-shopping',
        permission: ['CONTAINER_POINT_LIST']
      });
    }
    return {
      tabs
    };
  }
};
</script>
